import { apiBaseUrl } from '../../config'
import store from '../../store'

// getters
const getters = {
  mediaList: state => state.mediaList,
  selectedMedia: state => state.media
}

const actions = {
  loadMediaList(context, searchText) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/kaltura?token=${store.state.user.token}&search=${searchText}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadMediaList', data)
        resolve()
      }).catch(e => {
        context.commit('loadMediaList', [])
        console.error(e)
        reject()
      });
    })
  },
  getVideoMeta(context, params) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/kaltura/videoMeta?token=${store.state.user.token}&mediaId=${params.mediaId}&flavorParamsId=${params.flavorParamsId}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        resolve(data)
      }).catch(e => {
        reject()
      });
    })
  },
  getSubtitles(context, assetId) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/kaltura/subtitles?token=${store.state.user.token}&assetId=${assetId}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        resolve(data)
      }).catch(e => {
        reject()
      });
    })
  },
  setMedia(context, asset) {
    context.commit('setMedia', asset)
  }
}

const mutations = {
  setMedia(state, media) {
    if (media.visible) {
      state.mediaList.map(media => {
        media.visible = false
      })
    }
    media.visible = !media.visible
    Object.assign(state.media, media)
  },
  loadMediaList(state, items) {
    items.map(item => {
      item.visible = false
    })
    state.media.visible = false
    state.mediaList = items
  }
}
export default {
  state: initializeState(),
  mutations,
  actions,
  getters
}

function initializeState() {
  return {
    mediaList: [],
    media: {
      visible: false
    }
  }
}
